import { Component } from '@angular/core'

@Component({
  selector: 'messaging-extended-nav',
  template: ` <messaging-nav-groups></messaging-nav-groups> `,
})
export class MessagingExtendedNavComponent {}
